import { render } from "./viewInvoice.vue?vue&type=template&id=5dbdfd9b&scoped=true"
import script from "./viewInvoice.vue?vue&type=script&lang=js"
export * from "./viewInvoice.vue?vue&type=script&lang=js"

import "./viewInvoice.vue?vue&type=style&index=0&id=5dbdfd9b&scoped=true&lang=css"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dbdfd9b"]])

export default __exports__